import { ArrowLeft } from 'lucide-react';
import { formatCurrency } from '@/utils/helpers';

interface LoanHeaderProps {
  onBack: () => void;
  loanName: string;
  loanIdLabel: string | number;
  currentBalance: number | null | undefined;
  status: string | null | undefined;
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD';
}

export function LoanHeader({
  onBack,
  loanName,
  loanIdLabel,
  currentBalance,
  status,
  currency = 'USD',
}: LoanHeaderProps) {
  return (
    <div className="mb-6" data-test-id="loan-detail-header">
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
        data-test-id="back-button"
      >
        <ArrowLeft className="w-4 h-4" />
        Back
      </button>
      <div className="flex justify-between items-start">
        <div>
          <h1
            className="text-3xl font-bold text-gray-900"
            data-test-id="loan-name"
          >
            {loanName}
          </h1>
          <p className="text-gray-600 mt-1" data-test-id="loan-id">
            ID: {loanIdLabel}
          </p>
        </div>
        <div className="text-right">
          <p className="text-2xl font-semibold" data-test-id="current-balance">
            {formatCurrency(currentBalance, 2, currency)}
          </p>
          <p className="text-sm text-gray-600" data-test-id="loan-status">
            Status: {status || 'Active'}
          </p>
        </div>
      </div>
    </div>
  );
}
